<section *ngIf="(assignedEmployeeId === null || toggle === true) && token === 'dashboardToken'">
    <label for="task-assigned" class="form-label d-block">{{'Assignee' | translate}}</label>
    <ng-select [virtualScroll]="true" [items]="employeeDropdown" name="selectAssignee" [(ngModel)]="assignedEmployeeId"
        bindLabel="fullName" bindValue="id" class="ng-select-size-sm" (change)="assigned(assignedEmployeeId)">
        <ng-template ng-option-tmp let-item="item">
            <div class="media align-items-center">
                <img class="d-block rounded-circle mr-50" *ngIf="item.personalPictureFileName !== ''"
                    src="{{utility.serviceAddress}}images/employee/{{item.personalPictureFileName}}" height="26"
                    width="26" [alt]="item.fullName" />
                <img class="d-block rounded-circle mr-50" *ngIf="item.personalPictureFileName === ''"
                    src="assets/images/avatar.png" height="26" width="26" [alt]="item.fullName" />
                <div class="media-body">
                    <p class="mb-0">{{ item.fullName }}</p>
                </div>
            </div>
        </ng-template>
    </ng-select>
</section>
<section *ngIf="assignedEmployeeId !== null && toggle === false">
    <div class="media align-items-center">
        <img class="d-block rounded-circle mr-50" *ngIf="assignedEmployeePersonalPictureFileName !== ''"
            src="{{utility.serviceAddress}}images/employee/{{assignedEmployeePersonalPictureFileName}}" height="50"
            width="50" alt="{{assignedEmployeeFullName}}" />
        <img class="d-block rounded-circle mr-50" *ngIf="assignedEmployeePersonalPictureFileName === ''"
            src="assets/images/avatar.png" height="50" width="50" alt="{{assignedEmployeeFullName}}" />
        <p>{{assignedEmployeeFullName}}</p>
        <!-- <button type="button" class="btn btn-icon assigned0" rippleEffect (click)="assigned(0)" 
            *ngIf="token === 'dashboardToken'">
            <span><i class="fa fa-close"></i></span></button>-->
        <button type="button" class="btn btn-icon assigned0" rippleEffect (click)="onChangeToggleClicked()"
            *ngIf="token === 'dashboardToken'">
            <span><i class="fa fa-refresh"></i></span></button>
    </div>
</section>